var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Person.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Person;

Person.default = Person;
